import { Body, Box, Heading, BoxProps } from '@hover/blueprint';
import React from 'react';

interface Props extends BoxProps {}

const EstimationHeader: React.FC<Props> = props => (
  <Box flexDir="column" alignItems="flex-start" {...props}>
    <Body isBold size={200} color="neutral.600" mb={100}>
      CLAIMS ESTIMATION
    </Body>
    <Heading
      fontWeight={{ base: 600, desktop: 600 }}
      size={{ base: 500, tablet: 600 }}
      style={{ marginBottom: 0 }}
    >
      Easy Import, Fast Estimation
    </Heading>
  </Box>
);

export default EstimationHeader;
